import styled from '@emotion/styled'
import { Box } from '@mindfulchefuk/design-system'

export const ListItem = styled(Box)`
  list-style-type: none;
  padding: 0;
`

ListItem.defaultProps = { as: 'li' }
